export default __webpack_public_path__ + "static/2-f24fbe366b9ab550448016baa0bf9475.jpeg";